import { call, put } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/types';
import { complianceAPI } from '@/api';
import type { ListsResponse } from '@/api';
import { complianceListsActions } from '@/redux/actions';
import { parseError } from '@/redux/helpers';

function* fetchLists(): SagaIterator {
  try {
    const response: ListsResponse = yield call(complianceAPI.getLists);
    yield put(complianceListsActions.setData(response));
  } catch (error: unknown) {
    const { message } = parseError(error);
    yield put(complianceListsActions.setError(message));
  } finally {
    yield put(complianceListsActions.setLoading(false));
  }
}

export { fetchLists };
